export function mapAccessToken(state) {
    return state.mapAccessToken
}

export function mapApimKey(state) {
    return state.mapApimKey
}

export function mapStyle(state) {
    const mapDomain = 'https://geoservices-a.junghans-schneider.de/map/styles/';
    const mapFile = `/style.json?key=${state.mapAccessToken}`
    // const mapDomain = 'https://apim-p-gw02.adac.de/mapbox/map/styles/';
    // const mapFile = `/style.json`
    const styles = {
        day: `oeamtc-bright`,
        dayTraffic: `oeamtc-bright-los`,
        contrast: `bright`,
        contrastTraffic: `bright-los`,
        night: `dark`,
        nightTraffic: `dark-los`
    }
    let style = `${state.activeMapStyle}${state.mapTraffic || state.mapTrafficFromUrl ? 'Traffic' : ''}`;
    return `${mapDomain}${styles[style]}${mapFile}`;
}

export function activeMapStyle(state) {
    return state.activeMapStyle;
}

export function mapBounds(state) {
    return state.mapBounds
}

export function mapTraffic(state) {
    return state.mapTraffic
}

export function mapTrafficFromUrl(state) {
    return state.mapTrafficFromUrl
}

export function pinDrop(state) {
    return state.pinDrop
}

export function mapMoved(state) {
    return state.mapMoved
}

export function mapFullyLoaded(state) {
    return state.mapLoaded && state.userLocationLoaded
}

export function mapboxJsAccessToken(state) {
    return state.mapboxJsAccessToken
}

export function mapGlSupported(state) {
    return state.mapGlSupported
}

export function mapZoom(state) {
    return state.mapZoom
}